import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';

import NewCustomer from '@/views/pages/NewCustomer.vue';
import Profile from '@/views/pages/Profile.vue';
import Search from '@/views/pages/Search.vue';

import MasterLayout from '@/views/templates/MasterLayout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: MasterLayout,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Search,
        meta: { componentName: 'Search' }
      },
      {
        path: '/customer/new',
        name: 'CreateCustomer',
        component: NewCustomer,
        meta: {
          componentName: 'NewCustomer',
          keepAlive: false
        }
      },
      {
        path: '/customer/:uuid',
        name: 'Customer',
        component: Profile,
        meta: {
          componentName: 'Profile',
          keepAlive: false
        }
      },
      {
        path: '/customerby/:facet/:value',
        name: 'CustomerBy',
        component: Profile,
        meta: {
          componentName: 'Profile',
          keepAlive: false
        }
      }
      // {
      //   path: '/search/:query',
      //   name: 'Search',
      //   component: Search,
      //   meta: {
      //     componentName: 'Search'
      //   }
      // }
    ]
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (from.name !== null) {
    if (!to.meta.keepAlive) { // If the route is not a keep-alive route, keep-alive the component of the route it's going to
      store.commit('setInclude', [to.meta.componentName]);
    }
  }

  next();
});

export default router;
